import { createContext } from "react";

import { NoteService } from "types";
import { ServiceContextType } from "types/common/context";

const defaultService: NoteService = {
	getNotes() {
		throw new Error("service.getNotes is not implemented");
	},
	addNote() {
		throw new Error("service.addNote is not implemented");
	},
	editNote() {
		throw new Error("service.editNote is not implemented");
	},
	deleteNote() {
		throw new Error("service.deleteNote is not implemented");
	},
};

export type NoteServiceContextType = ServiceContextType<NoteService>;

const NoteServiceContext = createContext<NoteServiceContextType>({
	key: "default",
	service: defaultService,
});

export default NoteServiceContext;
